import React, { memo } from "react";
import { Redirect } from "react-router-dom";
import PublicRoutes from "./PublicRoutes";
import { UTILS } from "utils";
import { userTypes } from "config/Constants";
import { StreamRoomsPaths } from "features/byteplus/byteplus.routes";

function Auth() {
  const user = UTILS.getCurrentUser();
  const loggedInUserToken = user?.token
  
  return loggedInUserToken ? (
    <Redirect to={user?.userType === userTypes["STREAM-ROOM-ACCESS"] ? StreamRoomsPaths.list:"/app/dashboard"} />
  ) : (
    <PublicRoutes />
  );
}

export default memo(Auth);
